class Viewports {

    constructor() {
        this.userAgent = window.navigator.userAgent.toLowerCase();

        this.winW = window.innerWidth;
        this.winH = window.innerHeight;

        window.addEventListener("resize", () => {
            this.winW = window.innerWidth;
            this.winH = window.innerHeight;
        });
    }

    /**
     * @desc checking element is in view. This function works well to determine if the element is in view,
     * but it takes a little time to do the calculation to get top, bottom, left and right positions
     * @param object el
     * @return bool - true or false
     */
    isElmInViewport(el) {

        let rect = el.getBoundingClientRect();
        const top = parseInt(rect.top);
        const left = parseInt(rect.left);
        const bottom = parseInt(rect.bottom);
        const right = parseInt(rect.right);

        return (
            rect && top >= 0 && left >= 0 && bottom <= this.winH && right <= this.winW
        );
    }

    find = value => this.userAgent.indexOf(value) !== -1;
    macos = () => this.find('mac');
    ios = () => this.iphone() || this.ipod() || this.ipad();
    iphone = () => !this.windows() && this.find('iphone');
    ipod = () => this.find('ipod');
    ipad = () => this.find('ipad');
    android = () => !this.windows() && this.find('android');
    androidPhone = () => this.android() && this.find('mobile');
    androidTablet = () => this.android() && !this.find('mobile');
    blackberry = () => this.find('blackberry');
    blackberryPhone = () => this.blackberry() && !this.find('tablet');
    blackberryTablet = () => this.blackberry() && this.find('tablet');
    windows = () => this.find('windows');
    windowsPhone = () => this.windows() && this.find('phone');
    windowsTablet = () => this.windows && this.find('touch') && !this.windowsPhone();
    mobile = () => this.androidPhone() || this.iphone() || this.ipod() || this.windowsPhone() || this.blackberryPhone();
    tablet = () => this.ipad() || this.androidTablet() || this.windowsTablet() || this.blackberryTablet();
    desktop = () => !this.tablet() && !this.mobile();

}

export default Viewports;